import { observer } from 'mobx-react-lite'
import { type BookkeepingCompleteJobDialogViewModel } from './BookkeepingCompleteJobDialogViewModel'
import { useFeatures } from '@/contexts/root-store-context'
import { type JobDetailsViewModel } from '@/features/jobs/details/JobDetailsViewModel'
import { BookkeepingCompleteJobDialog } from '@/features/jobs/details/components/BookkeepingCompleteJobDialog'

export interface BookkeepingCompleteJobDialogContainerProps {
  vm: BookkeepingCompleteJobDialogViewModel
  jobVm: JobDetailsViewModel
}

export const BookkeepingCompleteJobDialogContainer = observer(
  function BookkeepingCompleteJobDialogContainer({
    vm,
    jobVm,
  }: BookkeepingCompleteJobDialogContainerProps) {
    const { shellInfo } = useFeatures(({ shell }) => ({
      shellInfo: shell.shellInfo,
    }))

    return (
      <BookkeepingCompleteJobDialog
        showing={vm.modal.showing}
        onClose={vm.modal.close}
        onSubmit={vm.submit}
        isSubmitPending={vm.submit.pending}
        isCorporateMode={Boolean(shellInfo.corporateMode)}
        isScopeChangeRequestPending={
          jobVm.scopeChangesVm.isScopeChangeRequestPending
        }
      />
    )
  },
)
